module.exports = __webpack_public_path__ + "public/images/coding-programming.274e181309b0e748381322ff89f6159c.jpg";